'use client';
/* Avec quel ALIQUOT ce point de CQI a été obtenu (03/10/2026).
 *
 * Lu à part (`GET ged/cqi-cartes/:id/aliquots`) plutôt que glissé dans la
 * lecture de la carte : le rattachement vit sur l'aliquot, et la carte n'a pas
 * à le recopier. Une absence se DIT (« aucun aliquot scanné ») : le scan n'est
 * pas obligatoire dans cette première version, et un vide muet se lirait comme
 * une donnée manquante par erreur. */
import React, { useEffect, useState } from 'react';
// L'heure du laboratoire (Tunis), pas celle du poste.
import { instantLabo } from '@/lib/aliquots-affichage';

type Lien = { niveau: number; code: string; codeLisible: string; produit: string; lot: string; flaconRef: string; decongeleLe: string; lotVerifie: boolean };

export function AliquotsDuPoint({ carteId, passageId }: { carteId: string; passageId: string }) {
  const [parPassage, setParPassage] = useState<Record<string, Lien[]> | null>(null);
  useEffect(() => {
    let vivant = true;
    void fetch(`/api/ged/ged/cqi-cartes/${encodeURIComponent(carteId)}/aliquots`, { credentials: 'include' })
      .then((r) => (r.ok ? r.json() : null))
      .then((d) => { if (vivant) setParPassage(d?.parPassage || {}); })
      .catch(() => { if (vivant) setParPassage({}); });
    return () => { vivant = false; };
  }, [carteId]);
  if (parPassage === null) return <span style={{ fontSize: 12, color: 'var(--text-muted)' }}>Aliquots : lecture…</span>;
  const liens = parPassage[passageId] || [];
  if (!liens.length) return <span style={{ fontSize: 12, color: 'var(--text-muted)' }}>Aucun aliquot scanné pour ce point.</span>;
  return (
    <div style={{ display: 'grid', gap: 3, fontSize: 12.5 }}>
      {liens.sort((a, b) => a.niveau - b.niveau).map((l) => (
        <span key={`${l.niveau}-${l.code}`}>
          N{l.niveau} — aliquot <strong style={{ fontFamily: 'var(--font-mono)' }}>{l.codeLisible}</strong> · {l.produit} · lot {l.lot}
          {l.decongeleLe ? ` · décongelé le ${instantLabo(l.decongeleLe)}` : ''} · flacon {l.flaconRef}
          {!l.lotVerifie && <em style={{ color: 'var(--amber-700)' }}> · lot de la carte non renseigné, concordance non vérifiée</em>}
        </span>
      ))}
    </div>
  );
}
